import {
    getRouteIdLoading,
    getRouteIdRequest,
    getRouteIdSuccess,
    getRouteIdReject,
} from "../../actions/route/getId";

export const getRouteId = (formData) => async (dispatch, getState) => {
    dispatch(getRouteIdLoading());
    try {
        const { data } = await getRouteIdRequest(formData, getState);
        dispatch(getRouteIdSuccess(data))
    } catch (error) {
        dispatch(getRouteIdReject(error))
    }
    return Promise.resolve();
};

export const clearStatus = () => (dispatch, getState) => {
    console.log("Entre a limpiar");
    dispatch(getRouteIdReject({}));
}